import React from 'react'
import { CarouselProvider } from 'pure-react-carousel'
import type { OverlayModalProps } from './types'
import OverlayCarousel from './overlay-carousel'

const OverlayModal: React.FC<OverlayModalProps> = ({
    images,
    video,
    isOverlayOpen,
    setOverlay,
    initialSlide,
    setSelectedImage,
    footer,
    onOverlayOpen,
    shouldAutoplayVideo = false,
}) => {
    return (
        <CarouselProvider
            naturalSlideWidth={1}
            naturalSlideHeight={1}
            totalSlides={video ? images.length + 1 : images.length}
            dragEnabled
            touchEnabled
            orientation="horizontal"
            isPlaying={false}
            dragStep={1}
            currentSlide={initialSlide}
        >
            <OverlayCarousel
                isOverlayOpen={isOverlayOpen}
                setOverlay={setOverlay}
                images={images}
                video={video}
                setSelectedImage={setSelectedImage}
                footer={footer}
                onOverlayOpen={onOverlayOpen}
                shouldAutoplayVideo={shouldAutoplayVideo}
            />
        </CarouselProvider>
    )
}

export default OverlayModal
